import type { ProductWithFixedRelatedProducts } from '../util/processRelatedProducts';
import stripHtml from '../../core/util/stripHtml';
import { useActiveFormattedProductPrice } from './useActiveFormattedProductPrice';

interface ProductMetaContentProps {
    activeSku?: string;
    product: ProductWithFixedRelatedProducts;
}

export const useProductMetaContent = ({
    product,
    activeSku,
}: ProductMetaContentProps) => {
    const textContent = stripHtml(product.description || '');
    const [firstSentence = ''] = textContent?.split('. ') || [];

    const price = useActiveFormattedProductPrice({
        activeSku,
        product,
    });

    return `${firstSentence}. ${price.priceLabel}`;
};
